$(document).ready(function () {
    $(document).on('click', '.kf-btn-toggle', function () {
        let element = $(this).data('element');
        $(element).click();
    })

    $('[data-toggle="tooltip"]').tooltip();
});
